import { forwardRef, Fragment, useContext, useImperativeHandle, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LoaderButton from "../loaderButton";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import useAddToCart from "../../../Context/hook/useAddtoCart";
import $ from "jquery";
export const AddToCartInfoAlert = forwardRef((props, ref) => {
  const [toastData, setToastData] = useState(null);
  const containerRef = useRef(null);
  const successRef = useRef(null);
  useImperativeHandle(ref, () => ({
    showAlert: (type, errItem) => {
      let bgClass = "";
      let titleClass = "";
      let titleText = "";
      let bodyContent = null;

      switch (type) {
        case "ITEM_ERROR":
          bgClass = "quickOrderError-red";
          titleClass = "quickOrderError-title-Red";
          titleText = `"${errItem.sku}" Not Found / Incorrect Code`;
          bodyContent = (
            <p>
              Product Code: <span>{errItem.sku}</span> Not Found. Please try again
            </p>
          );
          break;

        case "ITEM_REPLACE":
          bgClass = "quickOrderError-blue";
          titleClass = "quickOrderError-title-blue";
          titleText = (
            <Fragment>
              <span>“{errItem.sku}”</span> Not Available. Replaced with <span>{errItem.replaceCode}</span>
            </Fragment>
          );
          bodyContent = (
            <p>
              <Link to={errItem.replaceUrl} className="text-decoration-underline">
                View Replacement Product : <span>{errItem.replaceCode}</span>
              </Link>
              {errItem.replaceItemId && (
                <AddReplacementItemToCart id={errItem.replaceItemId ?? 0} handleCallback={handleClose} />
              )}
            </p>
          );
          break;

        case "ITEM_UNAVAILABLE":
          bgClass = "quickOrderError-yellow";
          titleClass = "quickOrderError-title-yellow";
          titleText = `"${errItem.sku}" Temporarily Unavailable`;
          bodyContent = (
            <p>
              Product Code: <span>{errItem.sku}</span> is currently unavailable
            </p>
          );
          break;

        case "ITEM_DISCONTINUED":
          bgClass = "quickOrderError-red";
          titleClass = "quickOrderError-title-Red";
          titleText = `"${errItem.sku}" Discontinued`;
          bodyContent = (
            <p>
              Product Code: <span>{errItem.sku}</span> is discontinued and no longer available.
            </p>
          );
          break;
        default:
          return;
      }

      setToastData({ bgClass, titleClass, titleText, bodyContent });
      if (containerRef.current) {
        $(containerRef.current).fadeIn(500);
      }
    },
    closeAlert: handleClose,
    showSuccess: () => {
      $(successRef.current).fadeIn(500).delay(6000).fadeOut(500);
    },
  }));

  const handleClose = () => {
    if (containerRef.current) {
      $(containerRef.current).fadeOut(500, () => {
        setToastData(null);
      });
    }
  };

  return (
    <Fragment>
      <div
        ref={containerRef}
        className="toast hide mt-3 col-lg-12 add-to-cart-info-alert"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        {toastData && (
          <div className={`quickOrderError ${toastData.bgClass}`} style={{ position: "relative" }}>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                zIndex: 10,
              }}
            />
            <div className={`quickOrderError-title ${toastData.titleClass}`}>
              <span className="wes-alert" />
              <h5>{toastData.titleText}</h5>
            </div>
            {toastData.bodyContent}
          </div>
        )}
      </div>

      <div
        ref={successRef}
        id="orderToast"
        className="toast hide mt-3"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-body">
          <div className="addedOrderLft">
            <i className="fa-solid fa-circle-check"></i>
          </div>
          <div className="addedOrderRft">
            <h5>Successfully added to cart</h5>
            <p>Please enter next product code above.</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
});

const AddReplacementItemToCart = ({ id, handleCallback }) => {
  const [isAdded, setIsAdded] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const { handleAddtoCartSimple } = useAddToCart();

  const handleAddtocartClick = async (e) => {
    setIsAdding(true);
    let result = await handleAddtoCartSimple(id, 1, "ADD");
    if (!result) setIsAdded(false);
    else setIsAdded(true);
    if (handleCallback && typeof handleCallback === "function") handleCallback(result);
  };
  return (
    <div className="button-effect addtocart-container mt-3">
      <LoaderButton
        onClick={handleAddtocartClick}
        className="btn replace-item-cart-btn"
        isLoading={isAdding}
        disabled={isAdded}
        loaderText="Adding Replacement..."
      >
        <span className="wes-cart" /> Add Replacement to Cart
      </LoaderButton>
    </div>
  );
};
